export default {
  title: 'Transfer Website',
  buttons: {
    cancel: 'Anulați',
    transfer: 'Transferați',
  },
  fields: {
    target_franchise: {
      label: 'Franciză Țintă',
      description: 'Selectați franciza către care transferați website-ul',
    },
    sync_companies: {
      label: 'Mapări Companii',
      description: 'Mapați companiile din franciza țintă la companiile din vitrină',
      franchise_company: 'Companie Franciză',
      storefront_company: 'Companie Vitrină',
      select_franchise_company: 'Selectați compania franciză',
      select_storefront_company: 'Selectați compania vitrină',
      franchise_company_required: 'Compania franciză este obligatorie',
      storefront_company_required: 'Compania vitrină este obligatorie',
    },
  },
  toasts: {
    failed_to_load_companies: 'Încărcarea companiilor a eșuat',
    no_companies_selected: 'Vă rugăm să adăugați cel puțin o mapare de companie',
    failed_to_transfer: 'Transferul website-ului a eșuat',
    transfer_success: 'Website transferat cu succes',
    franchise_already_connected: 'Franciza țintă este deja conectată la un website',
  },
};
